import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (typeof detail?.msg === "string") return detail.msg;
  return String(detail);
}

export async function downloadInvoice(submissionId, invoiceNo) {
  const res = await api.get(`/submissions/${submissionId}/invoice`, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `${invoiceNo || "invoice"}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function fileUrl(v) {
  if (!v) return "";
  if (typeof v === "string" && v.startsWith("data:")) return v;
  return `${process.env.REACT_APP_BACKEND_URL}/api/files/${v}`;
}

export const LOGO_URL = "https://res.cloudinary.com/dmzvcdkuu/image/upload/v1786261375/PSS_Towing_NoBG_oaaqsn.png";

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const STATUS_LABELS = {
  pending: "Pending",
  assigned: "Assigned",
  en_route: "En Route",
  arrived: "Arrived",
  completed: "Completed",
  cancelled: "Cancelled",
};

export const STATUS_COLORS = {
  pending: "bg-amber-500/15 text-amber-400 border-amber-500/40",
  assigned: "bg-sky-500/15 text-sky-400 border-sky-500/40",
  en_route: "bg-blue-500/15 text-blue-400 border-blue-500/40",
  arrived: "bg-violet-500/15 text-violet-400 border-violet-500/40",
  completed: "bg-emerald-500/15 text-emerald-400 border-emerald-500/40",
  cancelled: "bg-red-500/15 text-red-400 border-red-500/40",
};

export default api;
